import { skipToken } from '@reduxjs/toolkit/query';
import WorkspaceInheritanceAPI from '../WorkspaceInheritance/WorkspaceInheritanceAPI';
import useMyWorkspace from './useMyWorkspace';
import { UseQuerySubscription } from '@reduxjs/toolkit/dist/query/react/buildHooks';

type Options = Parameters<UseQuerySubscription<any>>[1];
function useMyWorkspacesChildren(options?: Options) {
  const { data: workspace } = useMyWorkspace();
  return WorkspaceInheritanceAPI.useGetChildrenQuery(
    workspace?.id ?? skipToken,
    options
  );
}

export default useMyWorkspacesChildren;
